import { useNavigate } from 'react-router-dom';

// The Spellago wordmark. Centered by default; click returns home.
const HomeLogo = ({ size = 'md' }) => {
    const navigate = useNavigate();
    const fontSize = size === 'lg' ? 'clamp(2.6rem, 12vw, 3.6rem)' : '1.6rem';

    return (
        <div style={{ display: 'flex', justifyContent: 'center', padding: '18px 0 6px' }}>
            <span
                className="sg-wordmark sg-anim-pop"
                style={{ fontSize }}
                onClick={() => navigate('/')}
            >
                spellago<span className="sg-wordmark__dot">.</span>
            </span>
        </div>
    );
};

export default HomeLogo;
